module.exports = __webpack_public_path__ + "img/pantalla-1-9.00492533.png";